import { Route, Routes } from "react-router-dom";
import { BloqueioAdministrativo } from "../pages/BloqueioAdministrativo";

function VeiculoRoutes() {
  return (
    <Routes>
      <Route path="/bloqueio" element={<BloqueioAdministrativo />} />
    </Routes>
  );
}
export { VeiculoRoutes };
